export default __webpack_public_path__ + "static/media/image_17.e9707a81.png";